/**
 * Header wishlist link (sections/header.liquid)
 * <wishlist-link> shows how many items are saved. Works on every page without loading the
 * product card script: reads the same storage key and listens for changes from any tab.
 */
(() => {
  if (customElements.get('wishlist-link')) return;

  const STORAGE_KEY = 'theme:wishlist';

  const count = () => {
    if (window.themeWishlist) return window.themeWishlist.get().length;
    try {
      const items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(items) ? items.length : 0;
    } catch {
      return 0;
    }
  };

  class WishlistLink extends HTMLElement {
    #controller = new AbortController();

    connectedCallback() {
      const { signal } = this.#controller;
      const update = () => this.#render();
      document.addEventListener('wishlist:change', update, { signal });
      window.addEventListener('storage', (event) => {
        if (event.key === STORAGE_KEY) update();
      }, { signal });
      window.addEventListener('pageshow', update, { signal });
      this.#render();
    }

    disconnectedCallback() {
      this.#controller.abort();
      this.#controller = new AbortController();
    }

    #render() {
      const total = count();
      const bubble = this.querySelector('[data-wishlist-count]');
      if (!bubble) return;
      bubble.hidden = total === 0;
      const number = this.querySelector('[data-wishlist-count-number]');
      if (number) number.textContent = total < 100 ? String(total) : '99+';
      const label = this.querySelector('[data-wishlist-count-label]');
      if (label) {
        // "1 saved item" / "3 saved items" (languages without a separate "one" form use the other text)
        let form = 'other';
        try {
          form = new Intl.PluralRules(document.documentElement.lang || undefined).select(total);
        } catch {
          form = total === 1 ? 'one' : 'other';
        }
        const template = (form === 'one' && this.dataset.labelCountOne) || this.dataset.labelCount || '';
        label.textContent = template.replace('[count]', () => String(total));
      }
    }
  }

  customElements.define('wishlist-link', WishlistLink);
})();
